import { render, staticRenderFns } from "./EditarLicencias.vue?vue&type=template&id=1e868bc2"
import script from "./EditarLicencias.vue?vue&type=script&lang=js"
export * from "./EditarLicencias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports